import { createAuthProvider } from "react-token-auth";

/*
    useAuth: return true if there are any access tokens in local storage
    login: store access token in local storage and it will be accessible in other components via useAuth hook
    authFetch: add the Authorization header automatically if access token stored in local storage
    logout: remove the access token from local storage
*/

export const [useAuth, authFetch, login, logout] = createAuthProvider({
  accessTokenKey: "access_token",
  onUpdateToken: (token) =>
    fetch(process.env.REACT_APP_API_URL + "/api/refresh", {
      method: "post",
      body: token.access_token,
    }).then((r) => r.json()),
});
